import styled from "styled-components";

export const StyledLiveWebinar = styled.iframe`
	width: 100%;
	height: 100%;
	min-height: 100dvh;
`;
